import Service from "../Service";

const resource = "FrzCtnResponsibleStop/";

export default {
    save(prd, requestID) {
        console.log("prd", prd)
        return Service.post(resource + "save", prd, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    listdetail(prd, requestID) {
        return Service.post(resource + "list", prd, {
            params: { requestID: requestID },
        });
    },
    listResponsible(prd, requestID) {
        return Service.post(resource + "listResponsible", {}, {
            params: { requestID: requestID },
        });
    },
    
}; 